import React from "react";
import "./FormLayout.css";

export default function FormLayout({ title, className, children }) {
  return (
    <div className={`FormLayout ${className}`}>
      {/* <div className="FormLayout__Title" span={24}>
        <span>{title}</span>
      </div> */}
      <div className="FormLayout__Body" span={24}>
        {children}
      </div>
    </div>

  );
}
